import React from "react";

function PersonalizedHeader({ router, name }) {
  return (
    <div
      className={"PersonalizedHeader"}
      style={{
        // width: "100%",
        // background: `url("static/images/PersonalizedHeader-bg.jpg")`,
        // backgroundSize: 'cover',
        textAlign: "center"
      }}
    >
      <img
        alt="20% off"
        style={{
          border: 0
          // width: "auto",
          // height: "auto"
        }}
        border="0"
        src={`https://tyacfemb.mi-content.com/p/rp/af3080d209bde58a.png?mi_u=&mi_name=${name}`}
      />
    </div>
  );
}

export default PersonalizedHeader;
